import { IProcessItem } from '@lib/Layout/UploadLayout'
import { FileUploadType } from '@shared/Services/ResumableUploadService'

export interface IExtendFile {
  duration: number
}

class FileHandlerBase {
  audioAccepts = ['audio/*']
  videoAccepts = ['video/*,.mkv']
  accepts = ['audio/*', 'video/*,.mkv']

  isAudioType = (fileType: string) => /^audio\//.test(fileType)

  isVideoType = (fileType: string) => /^video\//.test(fileType)

  getFileType = (item: IProcessItem) => {
    if (this.isAudioType(item.File.type)) return FileUploadType.Audio
    else if (this.isVideoType(item.File.type)) return FileUploadType.Video
    return undefined
  }

  sliceFiles = (files: File[]) => ({
    audios: files.filter((e) => this.isAudioType(e.type)),
    videos: files.filter((e) => this.isVideoType(e.type))
  })

  // private getVideoDuration = (url: string): Promise<number> => {
  //   return new Promise((resolve) => {
  //     const video = document.createElement('video')
  //     video.src = url
  //     video.onloadedmetadata = () => {
  //       resolve(video.duration)
  //       URL.revokeObjectURL(url) // Clean up the object URL
  //     }
  //   })
  // }

  getVideoDuration = (url: string, timeout = 5000): Promise<number> => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video')
      let timer: NodeJS.Timeout | null = null

      const handleLoadedMetadata = () => {
        clearTimeout(timer!)
        resolve(video.duration)
        cleanup()
      }

      const handleError = () => {
        clearTimeout(timer!)
        reject(new Error(`Failed to load video: ${url}`))
        cleanup()
      }

      const handleTimeout = () => {
        reject(new Error(`Video load timeout (${timeout}ms): ${url}`))
        cleanup()
      }

      const cleanup = () => {
        video.removeEventListener('loadedmetadata', handleLoadedMetadata)
        video.removeEventListener('error', handleError)
        video.src = '' // Giải phóng tài nguyên
        video.load() // Đảm bảo dừng tải video
        if (timer) clearTimeout(timer)
        if (url.startsWith('blob:')) URL.revokeObjectURL(url) // Chỉ revoke nếu là Object URL
      }

      // Thiết lập timeout
      timer = setTimeout(handleTimeout, timeout)

      video.addEventListener('loadedmetadata', handleLoadedMetadata)
      video.addEventListener('error', handleError)
      video.src = url

      video.load()
    })
  }

  getAudioDuration = (src: string, timeout = 5000): Promise<number> => {
    return new Promise((resolve, reject) => {
      const audio = new Audio(src)
      let timer: NodeJS.Timeout | null = null

      const handleLoadedMetadata = () => {
        clearTimeout(timer!)
        resolve(audio.duration)
        cleanup()
      }

      const handleError = () => {
        clearTimeout(timer!)
        reject(new Error(`Failed to load audio: ${src}`))
        cleanup()
      }

      const handleTimeout = () => {
        reject(new Error(`Audio load timeout (${timeout}ms): ${src}`))
        cleanup()
      }

      const cleanup = () => {
        audio.removeEventListener('loadedmetadata', handleLoadedMetadata)
        audio.removeEventListener('error', handleError)
        audio.src = '' // Giải phóng tài nguyên
        if (timer) clearTimeout(timer)
      }

      // Thiết lập timer để reject nếu load quá lâu
      timer = setTimeout(handleTimeout, timeout)

      audio.addEventListener('loadedmetadata', handleLoadedMetadata)
      audio.addEventListener('error', handleError)

      audio.load()
    })
  }
  getExtendFile = async (item: IProcessItem): Promise<IExtendFile> => {
    const fileType = this.getFileType(item)
    const url = URL.createObjectURL(item.File)
    switch (fileType) {
      case FileUploadType.Audio: {
        const duration = await this.getAudioDuration(url)
        return { duration }
      }
      case FileUploadType.Video: {
        const duration = await this.getVideoDuration(url)
        return { duration }
      }
      default:
        return { duration: 0 }
    }
  }
}
export const FileHandler = new FileHandlerBase()
